export function convertToMultiline(fields) {
  return (fields.length > 0 ? fields : [""]).map((field) => {
    return {value: field};
  });
}
export function toValue(formValue) {
  return formValue.map((field) => field.value);
}
